import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import swal from 'sweetalert2';

import { User } from '../../shared/models/user.model';

import { Select2Utility } from '../../shared/utilities/select2.utility';
import { Lista } from '../../shared/models/lista.model';

import { Select2OptionData } from 'ng2-select2';
import { ContractService } from '../../shared/services/contract.service';
import { SessionService } from '../../shared/services/session.service';
import { UserService } from '../../shared/services/user.service';
import { CacheService } from '../../shared/models/cache-service.model';

declare var jQuery: any;

@Component({
  selector: 'auth-contract',
  templateUrl: './auth-contract.component.html',
  styleUrls: ['./auth-contract.component.css']
})
export class AuthContractComponent implements OnInit {

  public contracts: Select2OptionData[];

  showSpinnerContinuar: boolean;

  contract: any;
  public selected: string;

  nombre: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _sessionService: SessionService,
    private _contractService: ContractService,
    private _userService: UserService
  ) { }

  ngOnInit() {

    this.contracts = this._sessionService.getContracts();
    this.nombre = this._sessionService.getCurrentUser().name;
    this.showSpinnerContinuar = false;
    this.selected = '';

  }

  continuar() {
    if (this.selected === '-1' || this.selected === '') {
      swal({
        title: 'Selección de Contrato',
        html: '<p style="font-size:14px">Debe seleccionar un contrato</p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
    } else {

      this.showSpinnerContinuar = true;
      this._sessionService.setSelectContract(this.selected);

      for (let _Contract of this._sessionService.getContracts()) {

        if (_Contract.id === this.selected) {
          this._sessionService.setSelectDocumentTypeContracted(_Contract.documentType);
        }
      }

      //busco datos de usuario

      let _user = this._sessionService.getCurrentUser();

      this._userService.getDataUserForContract(_user.user, this.selected).subscribe(
        res => {

          let _user = this._sessionService.getCurrentUser();
          _user.age = res.age;
          _user.birthDate = res.birthDate;
          _user.contractNumber = res.contractNumber;
          _user.documentId = res.documentId;
          _user.name = res.name;          
          this._sessionService.setCurrentUser(_user);          
          this._sessionService.setCache(new CacheService());

          //Saber si es contratante
          this._userService.isUpdateData({ user: res.user, contractNumber: res.contractNumber }).subscribe(
            res => {

              let __user = this._sessionService.getCurrentUser();
              __user.actualizacionMenu = res;
              this._sessionService.setCurrentUser(__user);

              this._contractService.getDataContract(this.selected).subscribe(
                res => {
                  this.showSpinnerContinuar = false;
                  this._sessionService.setDataContract(res, false);
                  
                      if (this._sessionService.getIdLogin() == "1") {
                        this.router.navigate(['/office/account_status/status'])
                      }else{
                        // this.router.navigate(['/office/home']);
                        let path = sessionStorage.getItem('urlsesion')
                       
                        if (!path) {
                          path = '/office/home';
                        }

                        this.router.navigate([path]);
                      }
                },
                err => {
                  this.showSpinnerContinuar = false;
                  console.log(err);
                }
              );

            },
            err => {
              this.showSpinnerContinuar = false;
              swal({
                title: 'Selección de Contrato',
                html: '<p style="font-size:14px">Ocurrio un inconveniente. Por favor intente nuevamente</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
              });
            });

        },
        err => {
          this.showSpinnerContinuar = false;
          swal({
            title: 'Selección de Contrato',
            html: '<p style="font-size:14px">Ocurrio un inconveniente. por favor intente nuevamente</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        }
      );

    }
  }

  public changed(e: any): void {
    this.selected = e.value;
  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/auth-contract/auth-contract.component.ts